import { memo } from 'react'
import RightSection from './RightSection'
import LeftSection from './LeftSection'

function Login() {
  return (
    <div className={'w-screen h-screen flex'}>
      <RightSection />
      <LeftSection />
    </div>
  )
}

export default memo(Login)
